import React from "react";

export const genColor = ({color}) => {
      if(!color) return null;
      return (
        <div>
          <div
            style={{width: '1.8rem' , height: '1.8rem', background: color, borderRadius: '0.4rem'}}
          />
        </div>
      );

};
